import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { useNgSession } from '../ng-session';

const { session } = useNgSession();

export const sessionTokenInterceptor = (config: InternalAxiosRequestConfig) => {
    // https://github.com/axios/axios/issues/5573#issuecomment-1644862647
    config.headers ??= {} as AxiosRequestHeaders;
    try {
        config.headers["X-Session-Token"] = session.value.SessionToken;
    } catch {}

    return config;
};

export const addSessionTokenInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(sessionTokenInterceptor, null, { synchronous: true });
};
